import React, { useContext } from 'react';
import { SaveAsPatchContext, ISaveAsPatchContext } from '../../saveAsPatchModalState/saveAsPatchModalContext';
import { TypeOfChanges } from './components/TypeOfChanges';
import { Info } from './components/Info';
import { RestaurantsMultipleSelect } from './components/RestaurantsMultipleSelect';
import { PropertiesMultipleSelect } from './components/PropertiesMultipleSelect';
import { Cron } from './components/Cron';
import { BtnBlock } from './components/BtnBlock';
import style from './Forms.module.scss';

export const Forms: React.FC = () => {
	const {
		saveData,
		setTypeOfChanges,
		setIDsRestaurant,
		setProperties,
		changePrice,
		toggleHasOpenPrice,
		changeOpenPrice,
		changeOpenPriceMaxThreshold,
		changeTaxPercent,
		toggleInStop,
		toggleIsCommentVisible,
		toggleIsFiscalized,
		toggleIsTaxPercentProtectedFromSync,
		changeActivationSchedule,
		changeDeactivationSchedule,
		changeTypeOfModalWindow,
		initialFormData,
		typeOfChanges,
		IDsSelectedRestaurant,
		selectedProperties,
		price,
		hasOpenPrice,
		openPrice,
		openPriceMaxThreshold,
		taxPercent,
		inStop,
		isCommentVisible,
		isFiscalized,
		isTaxPercentProtectedFromSync,
		activationSchedule,
		deactivationSchedule,
	} = useContext<ISaveAsPatchContext>(SaveAsPatchContext);

	return (
		<div className={style.container} data-test="CreateStudioModal">
			<TypeOfChanges setTypeOfChanges={setTypeOfChanges} typeOfChanges={typeOfChanges} />
			{typeOfChanges === 'basedChanges' && (
				<Info
					customerName={initialFormData.customerName}
					fetchedRestaurants={initialFormData.fetchedRestaurants}
					IDSelectedRestaurantOnRestPropsPage={initialFormData.IDSelectedRestaurantOnRestPropsPage}
					price={initialFormData.price}
					hasOpenPrice={initialFormData.hasOpenPrice}
					openPrice={initialFormData.openPrice}
					openPriceMaxThreshold={initialFormData.openPriceMaxThreshold}
					taxPercent={initialFormData.taxPercent}
					inStop={initialFormData.inStop}
					isCommentVisible={initialFormData.isCommentVisible}
					isFiscalized={initialFormData.isFiscalized}
					isTaxPercentProtectedFromSync={initialFormData.isTaxPercentProtectedFromSync}
					activationSchedule={initialFormData.activationSchedule}
					deactivationSchedule={initialFormData.deactivationSchedule}
					hasPortions={initialFormData.hasPortions}
				/>
			)}
			<RestaurantsMultipleSelect
				setIDsRestaurant={setIDsRestaurant}
				restaurants={initialFormData.fetchedRestaurants}
				IDSelectedRestaurantOnRestPropsPage={initialFormData.IDSelectedRestaurantOnRestPropsPage}
				IDsSelectedRestaurant={IDsSelectedRestaurant}
				typeOfChanges={typeOfChanges}
			/>
			<PropertiesMultipleSelect
				setProperties={setProperties}
				selectedProperties={selectedProperties}
				isCreatedOnPos={initialFormData.isCreatedOnPos}
				hasPortions={initialFormData.hasPortions}
			/>
			{typeOfChanges === 'independentChanges' && !!selectedProperties.length && (
				<Cron
					changePrice={changePrice}
					toggleHasOpenPrice={toggleHasOpenPrice}
					changeOpenPrice={changeOpenPrice}
					changeOpenPriceMaxThreshold={changeOpenPriceMaxThreshold}
					changeTaxPercent={changeTaxPercent}
					toggleInStop={toggleInStop}
					toggleIsCommentVisible={toggleIsCommentVisible}
					toggleIsFiscalized={toggleIsFiscalized}
					toggleIsTaxPercentProtectedFromSync={toggleIsTaxPercentProtectedFromSync}
					changeActivationSchedule={changeActivationSchedule}
					changeDeactivationSchedule={changeDeactivationSchedule}
					selectedProperties={selectedProperties}
					price={price}
					hasOpenPrice={hasOpenPrice}
					openPrice={openPrice}
					openPriceMaxThreshold={openPriceMaxThreshold}
					taxPercent={taxPercent}
					inStop={inStop}
					isCommentVisible={isCommentVisible}
					isFiscalized={isFiscalized}
					isTaxPercentProtectedFromSync={isTaxPercentProtectedFromSync}
					activationSchedule={activationSchedule}
					deactivationSchedule={deactivationSchedule}
					hasSchedulePriority={initialFormData.hasSchedulePriority}
				/>
			)}
			<BtnBlock
				onClose={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
				onSaveAndMakeOtherChanges={() => saveData('saveAndMakeOtherChanges')}
				onSaveAndClose={() => saveData('saveAndClose')}
				disabledSave={!IDsSelectedRestaurant.length || !selectedProperties.length}
			/>
		</div>
	);
};
